
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useEffect, useState } from "react";
import useTranslation from "next-translate/useTranslation";
import { FaAward } from "react-icons/fa";
import NarrowPage from "../../components/layout/narrow-page";
import Head from "next/head";
import { useMembership } from "@/redux/membership";
import { FREE_TIER } from "@chesshotel/constants";
import { useMetrica } from "@/lib/next-yandex-metrica";
import { gaEvent } from "@/lib/ga";
import { api } from "@/services/api";
import { trackEvent } from "@/services/eventTracker";
import { useRouter } from "next/router";
import PremiumWelcomePageContent from "@/modules/membership/PremiumWelcomePageContent";
export default function MembershipDone() {
    const { t } = useTranslation("common");
    const router = useRouter();
    const { tier } = useMembership();
    const { reachGoal, userParams } = useMetrica();
    const [hasAccess, setHasAccess] = useState(false);
    const [checkingAccess, setCheckingAccess] = useState(true);
    const [welcomeTier, setWelcomeTier] = useState<number | null>(null);
    useEffect(() => {
        if (tier !== FREE_TIER && hasAccess) {
            gaEvent({ category: "Memberships", action: "MembershipsDone" });
            reachGoal("membership_done");
            userParams({ membershipTier: tier });
            trackEvent("subscribed", { tier });
        }
    }, [tier, hasAccess]);
    useEffect(() => {
        let cancelled = false;
        const claimAccess = async (attempt = 0) => {
            if (cancelled) {
                return;
            }
            try {
                const response = await api.get("/membership/welcome/claim");
                if (cancelled) {
                    return;
                }
                if (response.data?.allowed) {
                    if (typeof response.data?.tier === "number" &&
                        response.data.tier !== FREE_TIER) {
                        setWelcomeTier(response.data.tier);
                    }
                    setHasAccess(true);
                    setCheckingAccess(false);
                    return;
                }
            }
            catch (error) {
                if (cancelled) {
                    return;
                }
                const status = (error as {
                    response?: {
                        status?: number;
                    };
                })?.response
                    ?.status;
                if (status === 401) {
                    router.replace("/signIn");
                    return;
                }
            }
            if (attempt < 10) {
                setTimeout(() => {
                    if (!cancelled) {
                        claimAccess(attempt + 1);
                    }
                }, 1200);
                return;
            }
            setCheckingAccess(false);
            router.replace("/memberships");
        };
        claimAccess();
        return () => {
            cancelled = true;
        };
    }, [router]);
    return (<NarrowPage title={t("Premium memberships")} icon={FaAward}>
      <Head>
        <title>{"Chess Hotel | " + t("Premium memberships")}</title>
        <meta name="description" content={t("description")}/>
        <meta name="keywords" content={t("keywords")}/>
      </Head>
      <div className="w-full flex flex-col items-center mb-8">
        <PremiumWelcomePageContent state={checkingAccess ? "loading" : hasAccess ? "ready" : "redirecting"} tier={welcomeTier ?? tier} loadingLabel={t("Loading...")} redirectingLabel={t("Redirecting...")} playLabel={t("Play now")} playHref="/play"/>
      </div>
    </NarrowPage>);
}

    async function __Next_Translate__getStaticProps__1a0fc0d5293__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/membership-done/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0fc0d5293__ as getStaticProps }
  